import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SkillsBlock1.css";
import Tag from "./Tag";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CloseIcon from "@mui/icons-material/Close";

const SkillsBlock1 = () => {
  const [solved] = useState(701);
  const [rank] = useState(43532);
  const [rating] = useState(1612);
  const [repos] = useState(25);
  const [contributions] = useState(1242);

  const [is_open_tag_expand, set_is_open_tag_expand] = useState(false);
  const open_tag_expand = () => {
    const tag_expand = document.getElementById("tag_expand");
    if (is_open_tag_expand === false) {
      tag_expand.style.display = "flex";
      tag_expand.style.opacity = "1";
      set_is_open_tag_expand(true);
    } else {
      tag_expand.style.display = "none";
      tag_expand.style.opacity = "0";
      set_is_open_tag_expand(false);
    }
  };
  return (
    <>
      <div id="tag_expand">
        <Tag id="tag1" src="Mongodb.png" />
        <Tag id="tag2" src="reactjs.png" />
        <Tag id="tag3" src="nodejs.png" />
        <Tag id="tag4" src="html5.png" />
        <Tag id="tag5" src="mysql.png" />
        <Tag id="tag6" src="java.png" />
        <Tag id="tag7" src="python.png" />
        <div className="tag" onClick={open_tag_expand}>
          {is_open_tag_expand ? (
            <>
              <div>
                <CloseIcon id="close_icon" />
              </div>
            </>
          ) : (
            <ArrowOutwardIcon id="view_more_icon" />
          )}
        </div>
      </div>
      <div id="skillsInner1">
        <div id="skillBlock1">
          <div id="codingProfiles">
            <div id="leetcode">
              <div className="tray">
                <div id="leetcode_img">
                  <Link
                    to="https://leetcode.com/singhpratham191/"
                    target="__blank"
                  >
                    <img src="leetcode2.png" alt="" />
                  </Link>
                </div>
                <div id="leetcode_data">
                  <div>
                    <span className="data_head">Submissions:</span>{" "}
                    <span style={{ animationDelay: "1s" }}>{solved}</span>
                    <br />
                    <span className="data_head">Rating:</span>{" "}
                    <span style={{ animationDelay: "1s" }}>{rating}</span>{" "}
                    <br />
                    <span className="data_head">Rank:</span>{" "}
                    <span style={{ animationDelay: "1s" }}>{rank}</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="custom_hr"></div>
            <div id="github">
              <div className="tray">
                <div id="github_img">
                  <Link to="https://github.com/pratham1singh" target="__blank">
                    <img src="github2.png" alt="" />
                  </Link>
                </div>
                <div id="github_data">
                  <span className="data_head">Contibutions:</span>{" "}
                  <span style={{ animationDelay: "1s" }}>{contributions}</span>{" "}
                  <br />
                  <span className="data_head">Repositories:</span>{" "}
                  <span style={{ animationDelay: "1s" }}>{repos}</span>
                  
                </div>
              </div>
            </div>
          </div>
          <div id="tags">
            <Tag id="tag1" src="Mongodb.png" />
            <Tag id="tag2" src="reactjs.png" />
            <Tag id="tag3" src="nodejs.png" />
            <div onClick={open_tag_expand} title="Click to see all skills.">
              <div className="tag">
                {is_open_tag_expand ? (
                  <>
                    <div>
                      <CloseIcon id="close_icon" />
                    </div>
                  </>
                ) : (
                  <ArrowOutwardIcon id="view_more_icon" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkillsBlock1;
